import { upperCaseFirstLetter } from "../../utils/upperCaseFirstLetter.js";

const fillingNameSuffixPattern = /(?:\s*[-–]\s*náplň)+\s*$/iu;

export function getFillingDisplayName(name: string): string {
	return upperCaseFirstLetter(name.replace(fillingNameSuffixPattern, "").trim());
}
